import { Entidad } from "../../../../data/Entidad";
import { IEscuela } from "../../../../data/entidad/Escuela";
import { MGrupo } from "../../../../data/model/MGrupo";
import { _DICC_GRUPO } from "../../../../data/modulo/Grupo";
import { DateV2 } from "../../../../util/DateV2";

export class MEscuelaForm implements Omit<IEscuela, keyof Pick<IEscuela, "EnUso" | "Modificacion" | "KinderFiltro" | "UsaEntradaSalidaQR" | "UsaFinanzas" | "UsaFactura">> {
    IdKinder: number;
    Nombre: string;
    ZonaHoraria: string;
    ConLogo: boolean;
    Correo: string;
    Direccion: string;
    CodigoPais: string;
    HoraEntradas: string[];
    HoraSalidas: string[];
    Tamanio: number;
    Telefono: string;
    TipoLicencia: Entidad.CTipoLicencia;
    CalendarioCfg: boolean;
    FechaRegistro: string;
    ModuloEval: Entidad.CTipoEvento.Logros | Entidad.CTipoEvento.Evaluacion;
    TiempoCobro: number;
    ToleranciaFactura: number;
    ToleranciaRetraso: number;
    Logo: string | File | any;
    Entrada: string;
    Salida: string;

    NumInterior?: string;
    Calle?: string;
    NumExterior?: string;
    CodigoPostal?: string;
    Ciudad?: string;
    Estado?: string;
    Pais?: string;
    LatLong?: string;

    DiasOperacion?: number[];

    IsChangedLogo?: boolean;
    IsChangedLatLong?: boolean;

    constructor(item?: IEscuela) {
        this.IsChangedLogo = false;
        this.IsChangedLatLong = false;
        this.DiasOperacion = [];
        this.HoraEntradas = [null, null, null, null, null, null, null];
        this.HoraSalidas = [null, null, null, null, null, null, null];
        this.NumInterior = "";
        this.Calle = "";
        this.NumExterior = "";
        this.CodigoPostal = "";
        this.Ciudad = "";
        this.Estado = "";
        this.Pais = "";
        this.LatLong = "";
        this.Entrada = "";
        this.Salida = "";

        if (!item) return;

        Object.assign(this, item);
        let splitDirection = (this.Direccion || "").split("\n");

        if (splitDirection.length == 8) {
            this.NumInterior = splitDirection[0];
            this.Calle = splitDirection[1];
            this.NumExterior = splitDirection[2];
            this.CodigoPostal = splitDirection[3];
            this.Ciudad = splitDirection[4];
            this.Estado = splitDirection[5];
            this.Pais = splitDirection[6];
            this.LatLong = splitDirection[7];
        }

        this.HoraEntradas?.forEach((hr, i) => {
            if (hr) {
                this.DiasOperacion.push(i + 1);
                this.Entrada = hr.slice(0, 5);
                this.Salida = this.HoraSalidas[i].slice(0, 5);
            }
        });
    }

    get gruposDeEscuela(): Map<number, MGrupo> {
        const grupos = new Map<number, MGrupo>();

        _DICC_GRUPO
            .forEach((d, k) => {
                if (d.IdKinder == this.IdKinder) {
                    grupos.set(k, d);
                }
            });

        return grupos;
    }

    public prepareDataForService() {
        let horaEntradas = [null, null, null, null, null, null, null];
        let horaSalidas = [null, null, null, null, null, null, null];
        this.Direccion = `${this.NumInterior}\n${this.Calle}\n${this.NumExterior}\n${this.CodigoPostal}\n${this.Ciudad}\n${this.Estado}\n${this.Pais}\n${this.LatLong}`;

        this.DiasOperacion.forEach((iDia) => {
            horaEntradas[iDia - 1] = new DateV2()
                ._SetTimeZone(this.ZonaHoraria)
                ._SetLocalStrHour(this.Entrada)
                ._Truncate("Second")
                ._ToISOString();
            horaSalidas[iDia - 1] = new DateV2()
                ._SetTimeZone(this.ZonaHoraria)
                ._SetLocalStrHour(this.Salida)
                ._Truncate("Second")
                ._ToISOString();
        })

        this.HoraEntradas = horaEntradas;
        this.HoraSalidas = horaSalidas;
    };
}